import type { DescribeToolActivityOptions } from "./describe-tool-activity-options";
import type { ToolActivityState } from "./tool-activity-state";
import { softFailedBrowser } from "./browser/soft-failed-browser";
import { softFailedCapture } from "./capture/soft-failed-capture";
/**
 * A running call is labelled in the progressive tense; a failed one says so.
 * Capture tools report their failures as prose on a `completed` call, so the
 * output is read too rather than trusting the status alone.
 */
export function toolActivityStateFor(
  toolName: string,
  options: DescribeToolActivityOptions | undefined,
): ToolActivityState {
  const isRunning = options?.status === "running";
  return {
    isRunning,
    hasFailed:
      options?.status === "failed" ||
      (!isRunning &&
        (softFailedCapture(toolName, options?.output) ||
          softFailedBrowser(toolName, options?.output))),
  };
}
